// React
import React from 'react'
import ReactDOM from 'react-dom'

// Component
import { App } from './App'

// Light Box
import SimpleReactLightbox from 'simple-react-lightbox'

// Tailwind
import 'assets/styles/tailwind.generated.css'

// React Ant design
import 'antd/dist/antd.css'

// Custom Styles
import 'assets/styles/global.scss'

// Locale
import './utils/i18n'

ReactDOM.render(
  <SimpleReactLightbox>
    <App />
  </SimpleReactLightbox>,
  document.getElementById('root'),
)
